"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CommentModel {
    constructor(parentId, id, messageText, createdBy, createdOn, updatedOn, resourceTypeId, resourceId, taggedUsers = [], children = [], isOpened = true) {
        this.parentId = parentId;
        this.id = id;
        this.messageText = messageText;
        this.createdBy = createdBy;
        this.createdOn = createdOn;
        this.updatedOn = updatedOn;
        this.resourceTypeId = resourceTypeId;
        this.resourceId = resourceId;
        this.taggedUsers = taggedUsers;
        this.children = children;
        this.isOpened = isOpened;
    }
}
exports.CommentModel = CommentModel;
//# sourceMappingURL=comment.model.js.map